import React from "react";

function CustomDomainIntegrationPage() {
  return <div>CustomDomainIntegrationPage</div>;
}

export default CustomDomainIntegrationPage;
